<template>
    <div class="m--t-2">
        <draggable v-model="selectedFilters" handle=".handle" class="catalogue-selected-items">
            <div :key="selectedFilter.id" v-for="selectedFilter in selectedFilters" class="catalogue-selected-item">
                <div class="handle catalogue-selected-item__handle"></div>
                <div class="catalogue-selected-item__label">
                    {{ messages[selectedFilter.type] }}
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import {messages} from '@/modules/ProjectModule/modules/ExtensionModule/messages/catalogue';

export default {
    name:       'CatalogueFilterSelected',
    components: {
        draggable
    },
    data() {
        return {
            messages
        }
    },
    computed:   {
        selectedFilters: {
            get() {
                return this.$store.getters['projects/project/extension/catalogue/selectedFilterDefinitions'];
            },
            set(value) {
                this.$store.dispatch('projects/project/extension/catalogue/changeProjectFilterDefinitionPosition', value);
            }
        }
    },
    methods:    {
        isActive(definitionId) {
            return this.$store.getters['projects/project/extension/catalogue/isProjectFilterActive'](definitionId) ? true : false;
        }
    }
}
</script>
